module.exports = __webpack_public_path__ + "6b0a8049e3b167b3868ccadbc9a5670f.pdf";